import { call, all } from 'redux-saga/effects';
import {watchGetDataNew, watchSetDataNew,watchGetDataLinkApi,watchGetDataLinkApibyid, watchGetDataEmailAzureByName, watchGetDataValidateDate, watchGetDataPlanByPass} from "./newSaga";
import {watchGetDataPlanHandle, watchSetDataPlanHandle} from "./planHandleSaga";
import {watchGetDataPlanHandleStep, watchSetDataPlanHandleStep,watchGetDataHistory,watchGetStatusActionHistory} from "./planHandleStepSaga";
import {watchDownloadFile, watchUploadFile} from "./fileSaga";
import { watchGetFilterReport } from './filterReportSaga';
import { watchGetDataTableReport } from './tableReportSaga';
import { watchGetHeaderTableReport } from './headerTableReport'
//IndexImportHygen

export default function* rootPlanHandleSaga() {
  yield all([
    call(watchGetDataNew),
    call(watchSetDataNew),
    call(watchGetDataPlanHandle),
    call(watchSetDataPlanHandle),
    call(watchGetDataPlanHandleStep),
    call(watchSetDataPlanHandleStep),
    call(watchUploadFile),
    call(watchDownloadFile),
    call(watchGetFilterReport),
    call(watchGetDataTableReport),
    call(watchGetHeaderTableReport),
    call(watchGetDataHistory),
    call(watchGetDataLinkApi),    
    call(watchGetDataLinkApibyid),  
    call(watchGetStatusActionHistory),  
    call(watchGetDataEmailAzureByName),
    call(watchGetDataValidateDate),
    call(watchGetDataPlanByPass),
    //IndexUsingHygen
    ])
}